export default {
    rick_event_highlights: "Event Highlights",
    risk_event_distribution: "Risk Event Distribution",
    risk_events_grouped_by_driver: "Risk Events, Grouped by Driver",
    risk_events_grouped_by_tag: "Risk Events, Grouped by Tag",
    risk_no_data: "No data",
    risk_events_by_driver_tag: "Tag",
    risk_events_by_tag_title: "Risk Events, Grouped by Tag",
    risk_events_by_tag_group: "Group",
    risk_events_by_tag_avg_events: "Average Risk Events",
    risk_events_by_tag_risk: "Risk Score",
    risk_events_by_tag_events: "Total Events",
    risk_events_by_tag_distance: "Distance",
    risk_events_trends_title: "Risk Event Trends",
    risk_events_trends_event_type: "Event Type",

    risk_events_by_driver_label: "Driver",
    risk_events_by_driver_avg_events: "Average Risk Events",
    risk_events_by_driver_risk: "Risk Score",
    risk_events_by_driver_events: "Total Events",
    risk_events_by_driver_distance: "Distance",
    risk_events_by_driver_global: "Configuring GLOBAL filters (affects ALL gadgets)",
    risk_events_by_driver_clear_global: "Clear all global filters and reset all gadgets",
    risk_events_by_driver_clear_specific: "Clear this gadget's custom filters (will use global filters)",

    // Pending Coaching Case Gadget
    pending_coaching_case: "Pending Coaching Cases",
    pending_coach_case_id: "Case ID",
    pending_coach_case_status: "Status",
    pending_coach_case_coach: "Coach",
    pending_coach_case_status_next_step: "Next Step",
    pending_coach_case_created_on: "Created On",
    pending_coach_case_status_pending: "Pending",
    pending_coach_case_status_evaluate: "Under Evaluation",
    pending_coach_case_status_completed: "Completed",
    pending_coach_case_status_escalate: "Escalated",
    pending_coach_case_next_step_assign_coach: "Assign Coach",
    pending_coach_case_next_step_initiate_coaching: "Initiate Coaching",
    pending_coach_case_next_step_monitor: "Monitor",
    pending_coach_case_next_step_pi_omited: "PI Omitted",
    pending_coach_case_next_step_pi_successfull: "PI Successful",
    pending_coach_case_next_step_judgement: "Judgement",
    pending_coach_case_next_step_pi_failed: "PI Fallido",

    // CasesCoachingSummary
    cases_coaching_summary: "Cases (Coaching) Summary",
    cases_coaching_summary_pending: "Pending",
    cases_coaching_summary_evaluation: "Evaluation",
    cases_coaching_summary_completed: "Completed",
    cases_coaching_summary_avgDuration: "Avg Duration",
    cases_coaching_summary_pISuccessRat: "PI Success Rat",
    cases_coaching_summary_eligibleDrivers: "Eligible Drivers",
    cases_coaching_summary_daysToComplete: "Days to Complete",
    cases_coaching_summary_createNew: "Create New",

    // DriverPerformanceCoach
    driver_performance_coach: "Driver Performance Coach",
    driver_performance_coach_coachName: "Coach",
    driver_performance_coach_pendingCount: "Pending Count",
    driver_performance_coach_lastCoaching: "Last Coaching",
    driver_performance_coach_avgPendingCount: "Avg Count",
    driver_performance_coach_avgDurationDays: "Avg Duration (Days)",
    driver_performance_coach_piSuccessRatePercent: "PI Success Rate",

    //Active Coaching Cases
    driver_performance_active_coaching_cases: "Active Coaching Cases",
    driver_performance_coach_caseNumber: "Case Number",
    driver_performance_coach_status: "Status",
    driver_performance_coach_nextStep: "Next Step",
    driver_performance_coach_createdOn: "Created",
    driver_performance_coach_daysPending: "Days Pending",
    driver_performance_coach_alert: "Alerts",

    // Hierarchy Filter (RiskEventsByTag)
    risk_events_by_tag_hierarchy: "Hierarchy",
    risk_events_by_tag_hierarchy_placeholder: "Select a hierarchy",
    risk_events_by_tag_level: "Level",
    risk_events_by_tag_level_placeholder: "Select a level",
    risk_events_by_tag_no_hierarchy: "No hierarchy (all tags)",
    risk_events_by_tag_hierarchy_config: "Tag Hierarchy",

    // Gadget Date Info Tooltips
    gadget_date_info_all_records: "All records (no date filter applied)",
    gadget_date_info_CasesCoachingSummary: "Cases (Coaching) Summary looks at all cases regardless of date. This number will continue to increase over time.",
    gadget_date_info_PendingCoachingCase: "Shows all pending coaching cases regardless of date.",
    gadget_date_info_ActiveCoachingCases: "Pulls cases that have a status of Pending, Monitor, or Judgement regardless of date.",
    gadget_date_info_DriverPerformanceCoach: "Shows performance metrics for all cases by coach regardless of date.",
}
